module.exports = __webpack_public_path__ + "static/terms-of-use-splash.de534ffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/terms-of-use-splash.jpg
// module id = 895
// module chunks = 152424973348419